import React, { useState, useEffect } from "react";
import Select from 'react-select';
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";

const FormEditProduct = () => {
  const [file, setFile] = useState("");
  const [preview, setPreview] = useState("");
  const [name, setName] = useState("");
  const [description, setDesc] = useState("");
  const [price, setPrice] = useState(0); 
  const [in_stock, setInstock] = useState(0);
  const [partnumber, setPartnumber] = useState("");
  const [serialnumber, setSerialnumber] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [categoryId, setSelectedCategory] = useState("");
  const [options, setOptions] = useState([]);
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  const { id, productId } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  const handlePriceChange = (values) => {
    setPrice(values.floatValue || 0); 
  };

  const handleStockChange = (values) => {
    const { floatValue } = values;
    setInstock(floatValue); 
  };

  useEffect(() => {
    const getProductById = async () => {
      setIsLoading(true);
      try {
        const result = await axios.get(`${API_BASE_URL}/category`, {
          headers: {
            'X-API-Key': API_KEY
          },
        }); 
        const datacategory = result.data;
        // Map the API data to the format react-select expects: { value: '', label: '' }
        const formattedOptions = datacategory.map(item => ({
          value: item.id,
          label: item.name,
        }));

        const response = await axios.get(
          `${API_BASE_URL}/products/${id}`, {
            headers: {
              'X-API-Key': API_KEY
            },
          }
        );
        const productId = response.data.id;
        const res = await axios.get(
          `${API_BASE_URL}/stocks/${productId}`, {
            headers: {
              'X-API-Key': API_KEY
            },
          }
        );
  
        // Find the matching object for the user's current value
        const initialValue = formattedOptions.find(
          option => option.value === response.data.categoryId
        );
        setOptions(formattedOptions);
        setSelectedCategory(initialValue);
        setError(null);
        setName(response.data.name);
        setDesc(response.data.description);
        setFile(response.data.image);
        setPreview(response.data.url);
        setPrice(response.data.price);
        setPartnumber(response.data.partnumber);
        setSerialnumber(response.data.serialnumber);
        setManufacturer(response.data.manufacturer);
        setInstock(res.data.in_stock);
      } catch (error) {
        setError('Failed to load options');
        console.error(error);
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }finally {
        setIsLoading(false);
      }
    };
    getProductById();
  }, [id, productId]);

  const loadImage = (e) => {
    const image = e.target.files[0];
    setFile(image);
    setPreview(URL.createObjectURL(image));
  };

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    console.log('Option selected:', selectedOption);
  };

  const updateProduct = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", name);
    formData.append("description", description);
    formData.append("price", price);
    formData.append("partnumber", partnumber);
    formData.append("serialnumber", serialnumber);
    formData.append("manufacturer", manufacturer);
    formData.append("categoryId", categoryId.value);
    formData.append("in_stock", in_stock);
    try {
      await axios.patch(`${API_BASE_URL}/products/${id}`, formData, {
        headers: {
          "Content-type": "multipart/form-data",
          'X-API-Key': API_KEY
        },
      });
      navigate("/products");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  return (
    <div className="container">
      <div className="columns">
        <div className="column is-centered">
          <h1 className="title is-size-5">Edit Products</h1>
          <div className="card is-shadowless">
            <form onSubmit={updateProduct}>
              <p className="has-text-centered">{msg}</p>
              <div className="field">
                <label className="label">Name</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Product Name"
                  />
                </div>
              </div>
              <div className="field">
                  <label className="label">Description</label>
                  <div className="control">
                      <textarea
                          className="textarea"
                          value={description}
                          onChange={(e) => setDesc(e.target.value)}
                          placeholder="Product Description"
                          rows="6"
                          required
                      ></textarea>
                  </div>
              </div>
              <div className="field">
                <label className="label">Price</label>
                <div className="control">
                
                  <NumericFormat
                    id="price-input"
                    className="input"
                    value={price}
                    onValueChange={handlePriceChange}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    placeholder="Price"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Part Number</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={partnumber}
                    onChange={(e) => setPartnumber(e.target.value)}
                    placeholder="Part Number"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Serial Number</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={serialnumber}
                    onChange={(e) => setSerialnumber(e.target.value)}
                    placeholder="Serial Number"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Manufacturer</label>
                <div className="control">
                  <input
                    type="text"
                    className="input"
                    value={manufacturer}
                    onChange={(e) => setManufacturer(e.target.value)}
                    placeholder="Manufacturer"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Category</label>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <div className="control">
                  <div className="is-fullwidth">
                    <Select
                        value={categoryId}
                        onChange={handleCategoryChange}
                        options={options}
                        isLoading={isLoading}
                        isClearable={true} 
                        placeholder="Select Category"
                      />
                  </div>
                </div>
              </div>
              <div className="field">
                <label className="label">In_Stock</label>
                <div className="control">
                  <NumericFormat
                    id="stock-input"
                    className="input"
                    value={in_stock}
                    onValueChange={handleStockChange}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    valueIsNumericString={true} 
                    placeholder="In_Stock"
                  />
                </div>
              </div>
              <div className="field">
                <label className="label">Image</label>
                <div className="control">
                  <div className="file">
                    <label className="file-label">
                      <input
                        type="file"
                        className="file-input"
                        onChange={loadImage}
                      />
                      <span className="file-cta">
                        <span className="file-label">Choose a file...</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              {preview ? (
                <figure className="image is-128x128">
                  <img src={preview} alt="Preview Image" />
                </figure>
              ) : (
                ""
              )}
              <div className="field">
                <div className="control">
                  <Link to="/products">
                  <button className="button is-small is-warning mr-1">
                    Cancel
                  </button>
                  </Link>
                  <button type="submit" className="button is-small is-success">
                    Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormEditProduct;
